export default __webpack_public_path__ + "static/media/no-record.1c9a9c01.svg";